import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Ecosystem } from '../components/Ecosystem';
import { WhyBlinkblis } from '../components/WhyBlinkblis';
import { FeaturedDecisions } from '../components/FeaturedDecisions';
import { Spotlights } from '../components/Spotlights';
import { YouTubeSection } from '../components/YouTubeSection';
import { Newsletter } from '../components/Newsletter';
import { Footer } from '../components/Footer';
import { useScreenInit } from '../useScreenInit';
export function Home() {
  useScreenInit();
  return <div className="min-h-screen bg-background text-white relative selection:bg-accent/30 selection:text-white" data-id="element-400" data-mp="29gd9waz4fq68">
      {/* Global Grain Overlay */}
      <div className="grain-overlay" data-id="element-401" data-mp="2dj9xyh7fkehk" />

      <Navbar data-id="element-402" data-mp="3kvae4s3vmly6" />

      <main data-id="element-403" data-mp="3kvtn3jbju002">
        <Hero data-id="element-404" data-mp="3kw21xgr8ffdw" />
        <Ecosystem data-id="element-405" data-mp="3kuiixie6yq8f" />
        <WhyBlinkblis data-id="element-406" data-mp="3kv0k8tfpnun7" />
        <FeaturedDecisions data-id="element-407" data-mp="3owvni3h7ci3m" />
        <Spotlights data-id="element-408" data-mp="3ow43zr0vqatp" />
        <YouTubeSection data-id="element-409" data-mp="3ovkhdx0aay9c" />
        <Newsletter data-id="element-410" data-mp="3oyynngc2jrm2" />
      </main>

      <Footer data-id="element-411" data-mp="30wjfqyjbda93" />
    </div>;
}